import { action, createStandardAction } from 'typesafe-actions';

export interface IAppState {
  isSideBarOpen: boolean;
  isSpinnerShowing: boolean;
  loadingQueue: number[];

  isInitializing: boolean;

  fullscreen: boolean;

  showConfirmModal: boolean;
  confirmModalText: string | null;
  confirmModalCallback: (() => void) | null;

}

const initialState: IAppState = {
  isSideBarOpen: false,
  isSpinnerShowing: false,
  loadingQueue: [],

  fullscreen: false,

  isInitializing: true,

  confirmModalCallback: null,
  confirmModalText: null,
  showConfirmModal: false
};

export enum actionTypes {
  PERFORM_INITIAL_APP_LOADING = 'PERFORM_INITIAL_APP_LOADING',
  FINISH_INITIALIZING = 'FINISH_INITIALIZING',

  TOGGLE_SIDE_BAR = 'TOGGLE_SIDE_BAR',

  TOGGLE_SPINNER = 'TOGGLE_SPINNER',
  TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN',

  OPEN_CONFIRM_MODAL = 'OPEN_CONFIRM_MODAL',
  CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL',
}

export const actions = {
  toggleSideBar: () => action(actionTypes.TOGGLE_SIDE_BAR),
  toggleSpinner: (payload: { value: boolean; key?: any }) =>
    action(actionTypes.TOGGLE_SPINNER, payload),
  performInitialAppLoading: () =>
    action(actionTypes.PERFORM_INITIAL_APP_LOADING),
  finishInitializing: () => action(actionTypes.FINISH_INITIALIZING),

  toggleFullscreen: createStandardAction(actionTypes.TOGGLE_FULLSCREEN)<{
    value: boolean;
  }>(),

  openConfirmModal: createStandardAction(actionTypes.OPEN_CONFIRM_MODAL)<{
    message?: string;
    callback: () => void;
  }>(),
  closeConfirmModal: createStandardAction(actionTypes.CLOSE_CONFIRM_MODAL)()
};

const reducer = (state: IAppState = initialState, action: any): IAppState => {
  const payload = action.payload;
  switch (action.type) {
    case actionTypes.TOGGLE_SIDE_BAR:
      return {
        ...state,
        isSideBarOpen: !state.isSideBarOpen,
      };
    case actionTypes.TOGGLE_SPINNER:
      let loadingQueue = state.loadingQueue;
      if (payload.value) {
        loadingQueue.push(+new Date());
        return {
          ...state,
          loadingQueue,
          isSpinnerShowing: payload.value,
        };
      } else {
        loadingQueue.pop();
        return {
          ...state,
          loadingQueue,
          isSpinnerShowing: !!loadingQueue.length,
        };
      }
    case actionTypes.TOGGLE_FULLSCREEN:
      return {
        ...state,
        fullscreen: payload.value,
      };
    case actionTypes.PERFORM_INITIAL_APP_LOADING:
      return {
        ...state,
        isInitializing: true,
      };
    case actionTypes.FINISH_INITIALIZING:
      return {
        ...state,
        isInitializing: false,
      };
    case actionTypes.OPEN_CONFIRM_MODAL:
      return {
        ...state,
        showConfirmModal: true,
        confirmModalText: payload.message || null,
        confirmModalCallback: payload.callback,
      };
    case actionTypes.CLOSE_CONFIRM_MODAL:
      return {
        ...state,
        showConfirmModal: false,
        confirmModalText: null,
        confirmModalCallback: null,
      };
    default:
      return state;
  }
};

export default reducer;
